import { Component, OnInit } from '@angular/core';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { CommentService } from 'src/app/services/comment.service';

@Component({
    selector: 'app-attached-information',
    templateUrl: './attached-information.component.html',
    styleUrls: ['./attached-information.component.scss'],
    standalone: false
})
export class AttachedInformationComponent implements OnInit {

  constructor( private commentService: CommentService) { }

  ngOnInit(): void {
  }

  addComment(workOrder: WorkOrder){
    this.commentService.addComment(workOrder[0].id)
  }


}
